import { useEffect, useState } from 'react';

import { axiosApiRequest } from 'helpers/api';
import { createMenuManagementAxiosInstance } from 'createAxiosInstance';

export type HistoryData = {
  detail: string;
  logUuid: string;
  timestamp: string;
  type: 'both' | 'cuboh_main_item' | 'cuboh_modifier';
};

type UseFetchBulkHistoryProps = {
  companyId: string;
  menuUuid: string;
  merchantId: string;
  shouldFetch: boolean;
};

export default function useFetchBulkHistory({
  companyId,
  menuUuid,
  merchantId,
  shouldFetch,
}: UseFetchBulkHistoryProps) {
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [bulkHistory, setBulkHistory] = useState<HistoryData[]>([]);

  useEffect(() => {
    async function handleFetchBulkHistory() {
      setIsLoadingHistory(true);
      const data = await axiosApiRequest({
        createAxiosInstance: createMenuManagementAxiosInstance,
        path: `company/${companyId}/cuboh/merchant/${merchantId}/markup/price/history/${menuUuid}`,
        data: undefined,
        setError: () => setFetchError(true),
      });

      if (data.data?.updates || data.type === 'success') {
        setBulkHistory(data.data?.updates || []);
      }

      setIsLoadingHistory(false);
    }

    if (shouldFetch) {
      void handleFetchBulkHistory();
    }
  }, [shouldFetch, companyId, merchantId, menuUuid]);

  return { isLoadingHistory, fetchError, bulkHistory };
}
